import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["checkDoctor", "doctorsOptions", "handlePhysicianChange", "severity", "error"];
import React from 'react';
import { PhysicianPicker, ErrorLabel } from './components/components';
import { SuggestBoxWrapper, StatementText } from './layout/WrapperDiv';
import { infoWidth } from './components/constants';
import en from '../translationDefaults/en';
export const OrderPhysicianPick = _ref => {
  let {
    checkDoctor,
    doctorsOptions,
    handlePhysicianChange,
    severity,
    error
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StatementText, {
    id: "verify-physician"
  }, /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
    width: infoWidth
  }, en.verifyPhysicianOrder), /*#__PURE__*/React.createElement(PhysicianPicker, _extends({
    doctor: checkDoctor,
    doctorsOptions: doctorsOptions,
    handlePhysicianChange: handlePhysicianChange,
    severity: severity
  }, props)), error && /*#__PURE__*/React.createElement(ErrorLabel, {
    errorLabel: error
  }));
};
export default OrderPhysicianPick;